<template>
  <!-- 言語切り替え：inline＝PCヘッダー、compact＝スマホヘッダーの🌐ボタン、row＝スマホのメニュー内 -->
  <div class="ls" :class="variant">
    <template v-if="variant === 'compact'">
      <button type="button" class="ls-btn" :aria-expanded="open ? 'true' : 'false'" aria-label="Language" @click.stop="open = !open">
        <span class="gl" aria-hidden="true">🌐</span>{{ short[$lang] }}
      </button>
      <div v-if="open" class="ls-pop" @click.stop>
        <a v-for="l in langs" :key="l" :href="href(l)" :class="{ on: l === $lang }" :lang="htmlLang[l]" @click.prevent="go(l)">{{ label[l] }}</a>
      </div>
    </template>
    <template v-else>
      <a v-for="l in langs" :key="l" :href="href(l)" :class="{ on: l === $lang }" :lang="htmlLang[l]" @click.prevent="go(l)">{{ variant === 'row' ? label[l] : short[l] }}</a>
    </template>
  </div>
</template>

<script>
import { LANGS, LANG_LABEL, LANG_SHORT, HTML_LANG, withLang, markSwitching } from '@/i18n'

export default {
  name: 'LangSwitch',
  props: { variant: { type: String, default: 'inline' } },
  data() {
    return { langs: LANGS, label: LANG_LABEL, short: LANG_SHORT, htmlLang: HTML_LANG, open: false }
  },
  watch: { $route() { this.open = false } },
  mounted() {
    this.onDoc = () => { this.open = false }
    document.addEventListener('click', this.onDoc)
  },
  beforeDestroy() { document.removeEventListener('click', this.onDoc) },
  methods: {
    href(l) { return withLang(this.$route.path, l) },
    go(l) {
      this.open = false
      if (l === this.$lang) return
      try { localStorage.setItem('v6-lang', l) } catch (e) { /* 保存できなくても切り替えは動く */ }
      markSwitching()
      this.$router.push({ path: withLang(this.$route.path, l), query: this.$route.query, hash: this.$route.hash }).catch(() => {})
      this.$emit('switched', l)
    },
  },
}
</script>

<style scoped>
.ls{display:flex;align-items:center;gap:2px;font-size:12.5px;font-weight:700}
.ls a{color:var(--v6-sub);text-decoration:none;padding:3px 6px;border-radius:4px;line-height:1.2}
.ls a.on{color:var(--v6-brand-d);background:var(--v6-brand-l)}
.ls.inline a+a{border-left:1px solid var(--v6-bd);border-radius:0 4px 4px 0}
.ls.compact{position:relative}
.ls-btn{display:flex;align-items:center;gap:1px;border:1px solid var(--v6-bd);background:#fff;border-radius:6px;padding:5px 3px;font-size:11px;font-weight:700;color:var(--v6-ink);cursor:pointer;font-family:inherit;line-height:1;white-space:nowrap}
.ls-btn .gl{font-size:10px}
.ls-pop{position:absolute;right:0;top:calc(100% + 6px);z-index:3000;background:#fff;border:1px solid var(--v6-bd);border-radius:8px;box-shadow:0 6px 18px rgba(0,0,0,.12);padding:4px;min-width:120px;display:flex;flex-direction:column}
.ls-pop a{padding:9px 12px;font-size:14px;color:var(--v6-ink)}
.ls.row{gap:8px;margin:4px 0 10px}
.ls.row a{flex:1;text-align:center;border:1px solid var(--v6-bd);padding:9px 4px;font-size:13.5px;color:var(--v6-ink)}
.ls.row a.on{border-color:var(--v6-brand);color:var(--v6-brand-d)}
</style>
